import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  path {\n    fill: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n  padding-left: 5px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding: 50px;\n  border-top: 1px solid ", ";\n  display: flex;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  @media screen and (max-width: ", "px) {\n    display: none;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  @media screen and (max-width: ", "px) {\n    display: block;\n    padding: 50px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: 50px;\n  @media screen and (max-width: ", "px) {\n    padding: 0 30px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 99;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  flex-grow: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import styled from '../utils/styling/styled-components';
var Container = styled.div(_templateObject(), function (props) {
  return props.theme.colors.white;
});
var Content = styled.div(_templateObject2(), function (props) {
  return props.theme.breakpoints.sm;
});
var Navigation = styled.div(_templateObject3());
var MobileFooter = styled.div(_templateObject4(), function (props) {
  return props.theme.breakpoints.sm;
});
var AcornsFooter = styled.div(_templateObject5(), function (props) {
  return props.theme.colors.ivory;
}, function (props) {
  return props.theme.breakpoints.sm;
});
var FooterContainer = styled.div(_templateObject6());
var FooterText = styled.div(_templateObject7(), function (props) {
  return props.theme.colors.stone;
});
var Logo = styled(AcornsIcon)(_templateObject8(), function (props) {
  return props.theme.colors.stone;
});
export var FullScreenPage = function FullScreenPage(_ref) {
  var navigation = _ref.navigation,
      content = _ref.content,
      mobileFooter = _ref.mobileFooter,
      acornsFooter = _ref.acornsFooter;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, null, navigation && /*#__PURE__*/React.createElement(Navigation, null, navigation), /*#__PURE__*/React.createElement(Content, null, content), mobileFooter && /*#__PURE__*/React.createElement(MobileFooter, null, mobileFooter), acornsFooter && /*#__PURE__*/React.createElement(AcornsFooter, null, /*#__PURE__*/React.createElement(FooterContainer, null, /*#__PURE__*/React.createElement(Logo, {
    icon: AcornsIcon.Icon.AcornsLogo,
    width: "24px",
    height: "24px"
  }), /*#__PURE__*/React.createElement(FooterText, null, "Grow your oak")))));
};